import {
  Button,
  Cell,
  CellGroup,
  Field,
  Form,
  NavBar,
  Space,
  Toast
} from 'vant'

export const vantPlugins = {
  install(app) {
    app.use(Button)
    app.use(Cell)
    app.use(CellGroup)
    app.use(Field)
    app.use(Form)
    app.use(NavBar)
    app.use(Space)
    app.use(Toast)
  }
}
